import { useCallback } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";
import InvestorsPageContainer from "./InvestorsPageContainer";

const FundStructureInvestorsPage = () => {
  usePageTitle("Investors");

  const getInvestorObjectDefinition = useCallback(() => adminApi.getObjectDefinition("Investor"), []);

  const [objectDefinitionResp, fetchDefinitionError] = useFetch(getInvestorObjectDefinition);

  if (fetchDefinitionError) {
    logError(fetchDefinitionError, "[FundStructureInvestorsPage]");
    return <DataLoadingFailed title="Failed to load investors" />;
  }

  if (objectDefinitionResp === undefined) {
    return <InlineLoader />;
  }

  return (
    <InvestorsPageContainer
      objectClassDefinition={objectDefinitionResp.objectClassDefinition}
      objectPermissions={objectDefinitionResp.objectPermissions}
    />
  );
};

export default FundStructureInvestorsPage;
